// import { Col, Container, Row } from "react-bootstrap";
// import productBg from "../../Images/banner1.png";
// import "./banner.css";
// const Banner = ({title}) => {
    
//     return ( 
//         <div className="image-container">
//             {/* <img src='https://modavenextjs.vercel.app/images/section/page-title.jpg' alt="Product-bg" /> */}
//              <img src={productBg} alt="Product-bg" />
//             <div className="overlay">
//                 <Container>
//                     <Row>
//                         <Col>
//                             <h2>{title}</h2>
//                         </Col>
//                     </Row>
//                 </Container>
//             </div>
//         </div>
//     );
// }

// export default Banner;

import { Col, Container, Row } from "react-bootstrap";
import productBg from "../../Images/banner1.png";
import mobileBg from "../../Images/banner2.png";
import "./banner.css";

const Banner = ({ title }) => {
  return (
    <div className="image-container">
      <img src={productBg} alt="Product-bg" className="desktop-banner" />
      <img src={mobileBg} alt="Product-bg" className="mobile-banner" />

      <div className="overlay">
        <Container>
          <Row>
            <Col>
              <h2>{title}</h2>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Banner;
